import React from 'react';
import LzSApp from '@lz/app/App';
import './PoweredByLogo.scss';

const LzXPoweredByLogo = () => {
  return (
    <React.Fragment>
      {!LzSApp.hide_powered_by && (
        <a
          className='powered-by'
          href={LzSApp.powered_by_url}
          target='_blank'
          rel='noreferrer'
        >
          Powered by{' '}
          <img src={LzSApp.powered_by_image} alt='Logic Zone' />
        </a>
      )}
    </React.Fragment>
  );
};

export default LzXPoweredByLogo;
